module.exports = __webpack_public_path__ + "img/off-chain.93bf8341.svg";